
import React, {Component, useState, useEffect} from 'react';
import {getApi} from '../../../../global/js/api';

const MonthlyRecommendedParking = (props) => {
	const [carParks, setCarParks] = useState([]);
	const [place, setPlace] = useState('');
	const [loadingHook, setLoadingHook] = useState(true);

	const fetchData = (url) => {
		if(props.api === 'no') {
			setLoadingHook(false);
			return;
		}

		setLoadingHook(true);
		getApi(url).then((data) => {
			if(data && data.carParks && data.carParks.length > 0) {
				setCarParks(data.carParks);
				setLoadingHook(false);
			}
		});
	};

	useEffect(() => {
		if(props.api === 'no') {
			setLoadingHook(false);
			return;
		}

		let url = `${props.api}?`;
		if(props.blockid) {
			url += `blockid=${props.blockid}&`;
		}

		if(props.place) {
			url += `state=${place}&`;
		}


		if(props.useCurrentLocation === true) {
			url = url + `latitude=${props.userLocation.lat}&longitude=${props.userLocation.lng}`;
			fetchData(url);
		} else {
			setPlace('NSW');
		}
	}, [props.blockid, props.place, props.useCurrentLocation]);

	useEffect(() => {
		if(props.api === 'no') {
			setLoadingHook(false);
			return;
		}

		if(!props.hasPills || place === '') {
			return;
		}

		let url = props.api;

		console.log(url, 'click');
		if(props.useCurrentLocation === true) {
			url = url + `?state=${place}&blockid=${props.blockid}` + `&latitude=${props.userLocation.lat}&longitude=${props.userLocation.lng}`;
			fetchData(url);
		} else {
			url = url + `?state=${place}&blockid=${props.blockid}`;

			fetchData(url);
		}
	}, [place]);

	const getParkingUrl = (carPark) => {
		if ($('body').hasClass('en-NZ') && carPark.monthlyParkingServiceIsAvailable && props.cpms) {
			return props.cpms.replace('{0}', carPark.cpmsCarparkCode || '');
		}
		return carPark.url;
	};

	const renderPropsCard = (el) => {
		return (
			// collapse7 is the id of get a quote accordion item
			<div className="card fade text-decoration-none show">
				<div>
					<div className="overflow-hidden card-image">
						<a href={el.url} style={{backgroundImage: `url(${el.imgUrl})`}}
							className="h-100 embed-responsive bg-cover transition hover:scale-1">
						</a>
					</div>
					<div className="p-4">
						<h3 className="name"><a href={el.url}>{el.name}</a></h3>
						<div className="status">{el.status}</div>
						<div className="price mb-4">{el.price}</div>
						<a className="btn btn-primary" href={getParkingUrl(el)} target="_blank">{props.ctaText}</a>
					</div>
				</div>
			</div>
		);
	};

	const renderCard = (el) => {
		return (
			// collapse7 is the id of get a quote accordion item
			<div className="card fade text-decoration-none show">
				<div>
					<div className="overflow-hidden card-image">
						<a href={el.url} style={{backgroundImage: `url(${el.imgUrl})`}}
							className="h-100 embed-responsive bg-cover transition hover:scale-1">
						</a>
					</div>
					<div className="p-4">
						<h3 className="name"><a href={el.url}>{el.name}</a></h3>
						<div className="status">{el.status}</div>
						<div className="price mb-4">{el.price}</div>
						<a className="btn btn-primary" href={getParkingUrl(el)} target="_blank">{props.ctaText}</a>
					</div>
				</div>
			</div>
		);
	};

	// if(!carParks.length) return null;
	return (
		<div className="container">
			<h2>{props.title}</h2>
			{/* {
				!props.useCurrentLocation === true && */}

			{
				props.hasPills &&
				<div className="row justify-content-md-center">
					<div className="col text-center pill-container">
						{
							props.states.map((state, i) =>
							<button type="button" className="btn btn-outline-danger pill-button" key={i} onClick={() => setPlace(state) }>{state}</button>
							)
						}
					</div>
				</div>
			}

			{/* } */}

			<div className="row position-relative">
				{
					props.carParks && props.carParks.length > 1 &&
					props.carParks.map((el, i) => (
						<div className="col-12 col-sm-6 col-md-6 col-lg-3 py-2 px-2 p-md-3" key={i}>
							{renderPropsCard(el)}
						</div>
					))
				}
				{
					!props.carParks &&
					carParks.map((el, i) => (
						<div className="col-12 col-sm-6 col-md-6 col-lg-3 py-2 px-2 p-md-3" key={i}>
							{renderCard(el)}
						</div>
					))
				}
				{/* loading spinner */}
				<div className={`loading-spinner ${loadingHook? 'is-active' : ''}`}>
					<img src="/assets/images/spinner.gif" />
				</div>
			</div>
		</div>
	);
};

MonthlyRecommendedParking.defaultProps = {
	hasPills: true,
};

export default MonthlyRecommendedParking;
